import ArrowIcon from '@assets/images/icons/tooltip-arrow.svg?react'
import { Times as CloseIcon } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

type ArrowPosition = 'left-top' | 'top-center'

interface Props {
  title: string
  description: string
  img: string
  link: string
  position?: ArrowPosition
  onLinkClick: () => void
  onCloseClick: () => void
}

export const VideoTutorial: React.FC<Props> = ({
  title,
  description,
  img,
  link,
  position,
  onLinkClick,
  onCloseClick,
}) => (
  <div className={css.video_tutorial}>
    <div className={css.header}>
      <div className={css.title}>{title}</div>
      <button className={css.close_btn} onClick={onCloseClick}>
        <CloseIcon className={css.icon} />
      </button>
    </div>
    <div className={css.description}>{description}</div>

    <a
      href={link}
      className={css.image_wrap}
      target="_blank"
      onClick={onLinkClick}
      rel="noopener"
    >
      <img className={css.image} src={img} alt="" />
    </a>

    {position && <ArrowIcon className={clsJoin(css.arrow, css[position])} />}
  </div>
)
